export enum SearchParam {
  NAME = 'name',
  SITE = 'site',
  SITE_ID = 'siteId',
  SERIAL = 'serial',
  PRODUCT = 'product',
  CUSTOMER = 'customer',
  STATUS = 'status',
  ENVIRONMENT = 'environment',
  PAGE_SIZE = 'pageSize',
  PAGE = 'page',
  ORDER_BY = 'orderBy',

  ACTOR = 'actor',
  ACTION = 'action',

  VIEW_MODE = 'viewMode',

  CONFIG = 'config',
  NOTES = 'notes',
}
